import { DateInput } from "basis";

function validateExpiryDate(...args) {
  const errors = DateInput.DEFAULT_PROPS.validate(...args);

  if (errors.length > 0) {
    return errors;
  }

  const [{ month, year }] = args;
  const expiryDate = new Date(2000 + Number(year), Number(month) - 1);
  const thisMonthDate = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
  );

  if (expiryDate < thisMonthDate) {
    errors.push("Expiry date can't be in the past");
  }

  return errors;
}

function parseExpiryDateResponse(data) {
  const maskedMobileNumber = data?.masked_mobile;

  if (!maskedMobileNumber) {
    return null;
  }

  const verifyOtpAction = data?.actions?.find(
    ({ name }) => name === "verify-otp",
  );

  if (!verifyOtpAction) {
    return null;
  }

  const resendOtpAction = data?.actions?.find(
    ({ name }) => name === "resend-otp",
  );

  if (!resendOtpAction) {
    return null;
  }

  return {
    maskedMobileNumber,
    verifyOtpAction,
    resendOtpAction,
  };
}

export { validateExpiryDate, parseExpiryDateResponse };
